<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9D0SQk/tc-custom/9781646566655.jpg?1723403959715" alt="This image is the cover for the book The Night Belongs to Us"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Night Belongs to Us
      </h1>
      <p class="bookDescription body article font2">
        <p>It doesn’t come as much of a surprise to Alex Ryan when she finds herself falling head over heels for Connie O’Reilly. How could she not? There isn’t a person alive who wouldn’t be drawn to the irresistibly beautiful and charming Connie. It seems impossible she could reciprocate -- not when Alex is so awkward, so timid, so very much a girl -- until what starts as a sweet friendship blossoms into something so much more than Alex could have dreamed of.<br/><br/>Alex knows what they have is a momentary thing, not enough to be called forever. Connie’s the most popular girl in the school, wealthy and admired. She’s going to go to Trinity, maybe marry a lawyer. She’s going to have everything Alex could never give her. She isn’t stupid, after all.<br/><br/>Status and reputation might mean nothing to Alex, but to Connie they are everything. The only out-lesbian they know is ridiculed by everyone she meets, and it’ll be a cold day in hell before Connie lets that be her.<br/><br/>But when rumours spark and new faces enter the picture, they’re both set to discover that, while it may be easy to walk away, it’s a lot harder to move on.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Katie Brown
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?316fe61e